import LobbyOverlay from './LobbyOverlay';
import { connect } from 'shared/node_modules/react-redux';
import { FE_ANIMATION } from 'shared/utils/featureFlags/constants';
import { currencyDisplayComponentName } from '../CurrencyDisplay/CurrencyDisplay';
import { chestComponentName } from '../BottomBar/BottomBar';

const mapStateToProps = state => {
  return {
    blockLobby: state.tutorial.blockLobby,
    animationFeature: state.featureFlags.enabledFeatures[FE_ANIMATION]?.enabled,
    currencyDisplayXPosition: state.animations[currencyDisplayComponentName]?.x,
    currencyDisplayYPosition: state.animations[currencyDisplayComponentName]?.y,
    currencyDisplayWidth: state.animations[currencyDisplayComponentName]?.width,
    currencyDisplayHeight: state.animations[currencyDisplayComponentName]?.height,
    chestPosition: state.animations[chestComponentName]?.x,
    chestWidth: state.animations[chestComponentName]?.width,
    chestHeight: state.animations[chestComponentName]?.height,
  };
};

export default connect(mapStateToProps, null)(LobbyOverlay);
